import { easeOut } from 'ol/easing';

export class ZoomByDelta {

  constructor (map, duration = 250) {
    this._map = map;
    this._duration = duration;
  }

  /* Modified from OL5 code control/Zoom.js */
  zoomByDelta (delta) {
    const view = this._map.getView();
    if (view) {
      const currentZoom = view.getZoom();
      if (currentZoom || currentZoom === 0) {
        animateZoom(view, currentZoom + delta, this._duration);
      }
    }
  }

}

export function animateZoom (view, zoom, duration) {
  if (duration > 0) {
    if (view.getAnimating()) {
      view.cancelAnimations();
    }
    view.animate({
      zoom,
      duration,
      easing: easeOut
    });
  } else {
    view.setZoom(zoom);
  }
}
